<template>
	<div class="app gray-bar-top">
		<div id="mstar-style-body">
			<h3 class="module-title">
				Morningstar Style Box<sup>TM</sup> - Fixed-Income
				<disclosure-superscript class="detail-page" anchor="msStyle" :statistics="['morningstarFIStyle']" />
			</h3>
			<div class="row">
				<div class="col-xs-4">
					<div class="morningstar-style-box-label"
						:style="{ 'background-image': `url(${getMstarStyleBox.labelUrl})` }" />
					<div class="morningstar-style-box"
						:style="{ 'background-image': `url(${getMstarStyleBox.styleBoxUrl})`, 'background-position': getMstarStyleBox.boxPosition }" />
				</div>
				<div class="col-xs-12 col-sm-8">
					<ul class="table-data">
						<li>{{ `${getMstarStyleBox.MstarRating} Quality` }}</li>
						<li>{{ `${getMstarStyleBox.MstarSenitvityRating} Interest-Rate Sensitivity` }}</li>
						<li><span class="sub-info">{{ `Morningstar data as of ${getMstarStyleBox.AsOfDate}(updated quarterly)`
								}}</span></li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters(['getBreakpoint', 'getMstarStyleBox'])
	}
};
</script>

<style lang="less" scoped>
#mstar-style-body {
	margin-bottom: 15px;

	.morningstar-style-box-label {
		position: relative;
		height: 110px;
		width: 110px;
	}

	.morningstar-style-box {
		position: absolute;
		height: 80px;
		width: 80px;
		bottom: 33px;
	}

	.table-data {
		list-style: none;
		padding-left: 0px;
		font-size: 14px;
		color: #333;
		font-family: "AvenirNextLTW01-Regular", Arial;
		line-height: 18px;

		li {
			margin-top: 13px;
		}
	}
}
</style>
